// TODO: Add correct values for all "domain.tld", "-placeholder" fields and
// manifest properties.

export default {
  siteUrl: "https://ims-fc.gr/",
  siteLang: "el-gr", // This should be the same as Prismic master locale
  title: "IMS - Individual Mortgage Solutions",
  shortTitle: "Individual Mortgage Solutions",
  description: "The IMS company, staffed by qualified mortgage brokers with extensive experience in the banking sector, is the largest partner of Greek Banks in mediation for the issuance of housing loans.",
  logoUrl: "https://ims-fc.gr/images/ims-logo.svg",

  // Values used in manifest
  siteBackgroundColor: "#fff",
  siteThemeColor: "#000",
  siteIcon: "./src/images/fav.png",

  // Image Details used as fallback at metadata
  defaultImage: "https://ims-fc.gr/images/logo.svg",
  defaultImageWidth: "512",
  defaultImageHeight: "512",
  defaultImageAlt: "IMS - Individual Mortgage Solutions",

  // Business Information
  BusinessName: "IMS - Individual Mortgage Solutions",
  BusinessAddress: "240, Andrea Syggrou Ave, pc 176 72 Kallithea",
  BusinessCity: "Athens",
  BusinessRegion: "Kallithea",
  BusinessPostalCode: "17672",
  BusinessCountry: "Greece",
  BusinessPhoneNumber: "+302109520047",
  BusinessEmail: "info@ims-fc.gr",
};
